<div class="container-fluid py-2 px-2 mb-sm-3">
  <div class="card">
    <div class="card-body">
      <!-- Add Address Card -->
      <div class=" d-flex justify-content-between mb-4 pt-2">
        <span class="fw-bold text-uppercase">Your addresses</span>
        <button class="float-end btn btn-sm btn-outline-danger" role="button" (click)="visible = true"><i class="pi pi-plus"></i> Add New</button>
      </div>
      <!-- Address Cards -->
      <div class="row">
        <div class="{{activeOption == 'Select' ? 'col-lg-12' : 'col-12' }} col-md-4 col-lg-3 py-1 px-1" *ngFor="let address of addresses; let indx = index">
          <div class="card py-3 card-custom h-100 position-relative" *ngIf="indx < limit">
            <div class="card-body">
              <div class="{{activeOption == 'Select' ? 'col-md-11' : 'col-md-12' }}">
                <h5 class="fs-7">
                  <input type="radio" name="address" class="mx-1" [value]="address" [(ngModel)]="selectedAddress" (change)="selectAddress(address)" *ngIf="activeOption == 'Select'"/>
                  <strong>{{ address.name+' '+address.lastName }}</strong>
                  <a *ngIf="activeOption == 'Remove'" role="button" class="text-danger float-end" (click)=confirmDelete(address.id)><i class="pi pi-trash"></i> Remove</a>
                </h5>
                <p class="fs-7 mb-3">{{ address.fullAddress }}</p>
              </div>
              <div *ngIf="!address.default" class="align-items-baseline fs-7 position-absolute bottom-0 start-0 p-3 py-3">
                <a *ngIf="activeOption == 'Remove'" role="button" class="text-danger" (click)="selectDefaultAddress(address)"><i class="pi pi-check-circle"></i> Set As Default</a>
              </div>
              <div *ngIf="address.default" class="align-items-baseline fs-7 position-absolute bottom-0 end-0 p-3 py-3">
                <a role="none" class="text-success"><i class="pi pi-verified"></i> Default</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<p-dialog header="Add your address" [modal]="true" [(visible)]="visible" [style]="{ width: '40rem' }">
  <div class="container" style="max-width: 600px; max-height: 100%">
    <app-manage-address [defaultAddress]="addressForm" (formData)="getFormData($event)"></app-manage-address>
  </div>
</p-dialog>
<p-dialog header="Confirm Deletion" [modal]="true" [(visible)]="visibledel"
          [style]="{ width: '40rem', borderRadius: '8px' }" [breakpoints]="{ '640px': '90%' }">
  <div class="container p-2" style="max-width: 600px;">
    <!-- Content Section -->
    <div class="d-flex flex-column align-items-center gap-3 mb-5">
      <h4 class="text-lg font-semibold text-center mb-2">
        Are you sure you want to delete this address?
      </h4>
    </div>
    <!-- Action Buttons -->
    <div class="d-flex justify-content-center align-items-center  gap-3 px-2">
      <button type="button"
              class="btn btn-outline-secondary"
              (click)="visibledel=false">
        Cancel
      </button>
      <button type="button"
              class="btn btn-danger"
              (click)="deleteAddress(selectedAddressId)"
              style="min-width: 100px;">
        <i class="pi pi-trash mr-2"></i>
        Delete
      </button>
    </div>
  </div>
</p-dialog>
